import nx from '@jswork/next';

const defaults = {
  sat: {
    total: { min: 400, max: 1600 },
    reading_and_writing: { min: 200, max: 800 },
    math: { min: 200, max: 800 },
  },
  act: {
    total: { min: 1, max: 36 },
    english: { min: 1, max: 36 },
    math: { min: 1, max: 36 },
    reading: { min: 1, max: 36 },
    science: { min: 1, max: 36 },
    writing: { min: 1, max: 36 },
  },
  ap: {
    score: { min: 1, max: 5 },
  },
  ib: {
    total: { min: 0, max: 45 },
    studies_in_language_and_literature: { min: 0, max: 7 },
    language_acquisition: { min: 0, max: 7 },
    individuals_and_societies: { min: 0, max: 7 },
    experimental_science: { min: 0, max: 7 },
    mathematics: { min: 0, max: 7 },
    the_arts: { min: 0, max: 7 },
  }
};

export default (type: string, field: string) => {
  return nx.get(defaults, `${type}.${field}`);
}
